import _extends from '@babel/runtime/helpers/extends';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default from 'react';
import { iconSize } from '../../../utils/helpers.js';

/* eslint-disable max-len */

var StatusTimer = (function (_a) {
  var _a$size = _a.size,
      size = _a$size === void 0 ? 'xs' : _a$size,
      props = __rest(_a, ["size"]);

  return /*#__PURE__*/React__default.createElement("svg", _extends({}, props, {
    width: iconSize[size],
    height: iconSize[size],
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.87203 4C6.39042 4 6 4.39042 6 4.87203C6 6.7029 6.82179 8.43708 8.2388 9.59645L10.2862 11.2716C10.7464 11.6481 10.7464 12.3519 10.2862 12.7284L8.2388 14.4035C6.82179 15.5629 6 17.2971 6 19.128C6 19.6096 6.39042 20 6.87203 20H17.3633C17.8449 20 18.2353 19.6096 18.2353 19.128C18.2353 17.2971 17.4135 15.5629 15.9965 14.4035L13.9491 12.7284C13.4889 12.3519 13.4889 11.6481 13.9491 11.2716L15.9965 9.59645C17.4135 8.43708 18.2353 6.7029 18.2353 4.87203C18.2353 4.39042 17.8449 4 17.3633 4H6.87203ZM11.4921 15.3793L8.80721 17.7659C8.48379 18.0534 8.68714 18.5882 9.11985 18.5882H15.115C15.5477 18.5882 15.751 18.0534 15.4276 17.7659L12.7427 15.3793C12.3861 15.0624 11.8487 15.0624 11.4921 15.3793Z",
    fill: "currentColor"
  }));
});

export { StatusTimer as default };
